import { createElement } from 'react'
import { ElementFactory, Serializer } from 'survey-core'
import { ReactQuestionFactory, SurveyQuestionElementBase } from 'survey-react-ui'
import { SurveyRadio, CUSTOM_TYPE } from './SurveyRadioModel'
import { SurveyRadioContent } from './SurveyRadioContent'

export function registerRadioQuestion (): void {
  ElementFactory.Instance.registerElement(
    CUSTOM_TYPE,
    (name) => {
      return new SurveyRadio(name)
    }
  )

  Serializer.addClass(
    CUSTOM_TYPE,
    [{
      name: 'radioMatrix',
      category: 'general'
    }, {
      name: 'extraInfo',
      type: 'string',
      category: 'general'
    }, {
      name: 'uploadedFileName',
      type: 'string',
      category: 'general',
      visible: false
    }, {
      name: 'uploadedFileKey',
      type: 'string',
      category: 'general',
      visible: false
    }],
    function () {
      return new SurveyRadio('')
    },
    'radiogroup'
  )

  ReactQuestionFactory.Instance.registerQuestion(CUSTOM_TYPE, (props) => {
    return createElement(SurveyQuestionRadio, props)
  })
}

export class SurveyQuestionRadio extends SurveyQuestionElementBase {
  get question (): SurveyRadio {
    return this.questionBase as SurveyRadio
  }

  renderElement (): JSX.Element {
    return <SurveyRadioContent question={this.question} />
  }
}

// Re-export types for external use
export { type RadioMatrixItem, type RadioMatrix } from './types'
export { SurveyRadio } from './SurveyRadioModel'
